import React from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';

import Spin from '../../../components/loading';
import UserBasicInfo from './userBasicInfo';
import UserTransactionsList from './userTransactionsList';
import UserComments from './UserComments';
import UserExchangedTickets from './userExchangedTickets';
import UserSentFactors from './userSentFactors';
import UserReservationsList from './userReservationsList';
import AlertAndConfirmation from '../../../utils/AlertAndConfirmation';

import * as userActions from '../../../redux/users/actions';
import * as cafeActions from '../../../redux/cafes/actions';

class UserDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: '3',
    };
  }

  componentDidMount() {
    if (this.props.location.state.id) {
      this.props.getAllCafeNamesForPanel();
      this.props.getAllUserInfo(this.props.location.state.id);
    } else {
      this.props.history.push('/users');
    }
  }

  toggle = tab => {
    if (this.state.activeTab !== tab) {
      this.setState({ activeTab: tab });
    }
  };

  handleAlert = () => {
    AlertAndConfirmation({ text: this.state.errorText, type: 'error' });
    this.setState({ errorFlag: false });
  };

  render() {
    let { activeTab } = this.state;
    let { id } = this.props.location.state;
    let { loading, message, failed, error } = this.props;
    let {
      avatarUrl,
      birthDate,
      firstName,
      lastName,
      gender,
      maritalStatus,
      marriageDate,
      mobileNumber,
      email,
      cafeId,
      roleId,
    } = this.props.userDetailsList && this.props.userDetailsList.length && this.props.userDetailsList[0];

    return (
      <React.Fragment>
        {this.state.errorFlag && this.handleAlert()}
        <section className={`p-1 col-12`}>
          <div className="col-12 d-flex justify-content-between align-items-center">
            <h3 className="text-right text-muted py-4">{locales('titles.userInfoDetails')}</h3>
            <div>
              <button onClick={() => this.props.history.push(`/users`)} className="btn btn-default w-5 mx-1">
                <i className="fa fa-reply"/>
                {locales('labels.cancel')}
              </button>
            </div>
          </div>

          <Spin spinning={loading}>
            <article>
              <main className="col-12 p-0">
                {error ? (
                  <div className="alert alert-danger">{locales('messages.server.error')}</div>
                ) : (
                  <>
                    {failed && <div className="alert alert-danger">{message}</div>}
                    <div className="col-12">
                      <UserBasicInfo
                        loading={!this.props.userDetailsList.length ? true : false}
                        avatarUrl={avatarUrl}
                        birthDate={birthDate}
                        firstName={firstName}
                        lastName={lastName}
                        gender={gender}
                        maritalStatus={maritalStatus}
                        marriageDate={marriageDate}
                        mobileNumber={mobileNumber}
                        email={email}
                        cafeId={cafeId}
                        cafeNamesList={this.props.cafeNamesList}
                        roleId={roleId}
                      />
                    </div>
                    <div className="col-12 py-5">
                      <Nav className="p-0" tabs>
                        <NavItem className="d-flex">
                          <NavLink
                            className={`${activeTab === '1' ? 'bg-primary text-white' : ''} ${classnames({
                              active: activeTab === '1',
                            })}`}
                            onClick={() => {
                              this.toggle('1');
                            }}
                          >
                            {locales('titles.userTransactionsList')}
                          </NavLink>
                          <NavLink
                            className={`${activeTab === '2' ? 'bg-primary text-white' : ''} ${classnames({
                              active: activeTab === '2',
                            })}`}
                            onClick={() => {
                              this.toggle('2');
                            }}
                          >
                            {locales('titles.userReservationsList')}
                          </NavLink>
                          <NavLink
                            className={`${activeTab === '3' ? 'bg-primary text-white' : ''} ${classnames({
                              active: activeTab === '3',
                            })}`}
                            onClick={() => {
                              this.toggle('3');
                            }}
                          >
                            {locales('titles.userComments')}
                          </NavLink>
                          <NavLink
                            className={`${activeTab === '4' ? 'bg-primary text-white' : ''} ${classnames({
                              active: activeTab === '4',
                            })}`}
                            onClick={() => {
                              this.toggle('4');
                            }}
                          >
                            {locales('titles.exchangeUserTickes')}
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            className={`${activeTab === '5' ? 'bg-primary text-white' : ''} ${classnames({
                              active: activeTab === '5',
                            })}`}
                            onClick={() => {
                              this.toggle('5');
                            }}
                          >
                            {locales('titles.sentFactorsToUser')}
                          </NavLink>
                        </NavItem>
                      </Nav>
                      <TabContent className="p-2" activeTab={this.state.activeTab}>
                        <TabPane tabId="1">
                          <UserTransactionsList
                            financialTransactions={
                              this.props.userDetailsList.length && this.props.userDetailsList[1]
                            }
                            userId={id}
                          />
                        </TabPane>
                        <TabPane tabId="2">
                          <UserReservationsList userId={id}/>
                        </TabPane>
                        <TabPane tabId="3">
                          <UserComments userId={id}/>
                        </TabPane>
                        <TabPane tabId="4">
                          <UserExchangedTickets
                            userId={id}
                            userTicketsList={
                              this.props.userDetailsList.length && this.props.userDetailsList[3]
                            }
                          />
                        </TabPane>
                        <TabPane tabId="5">
                          <UserSentFactors
                            userId={id}
                            userInvoicesList={
                              this.props.userDetailsList.length && this.props.userDetailsList[4]
                            }
                          />
                        </TabPane>
                      </TabContent>
                    </div>
                  </>
                )}
              </main>
            </article>
          </Spin>
        </section>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    loading: state.userReducer.loading,
    message: state.userReducer.message,
    failed: state.userReducer.failed,
    error: state.userReducer.error,
    userDetailsList: state.userReducer.userDetailsList || [],

    cafeNamesList: state.cafesReducer.cafeNamesList,
    cafeNamesListLoading: state.cafesReducer.cafeNamesListLoading,
    cafeNamesListFailed: state.cafesReducer.cafeNamesListFailed,
    cafeNamesListMessage: state.cafesReducer.cafeNamesListMessage,
    cafeNamesListError: state.cafesReducer.cafeNamesListError,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getAllUserInfo: id => dispatch(userActions.getAllUserInfo(id)),
    getAllCafeNamesForPanel: () => dispatch(cafeActions.getAllCafeNamesForPanel()),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(UserDetails));
